import { Mtds } from 'prove-common'
import type { ResultsReceipt } from './resultsUpload'

export type ResultsReceiptCardProps = {
  receipt: {
    requisitionId: string
    data: ResultsReceipt
  }
}

export const ResultsReceiptCard = ({ receipt }: ResultsReceiptCardProps) => (
  <Mtds.Card as={Mtds.Grid} data-pad='4'>
    <Mtds.Heading as='h2' data-size='sm'>
      Siste bekreftede innsending
    </Mtds.Heading>
    <Mtds.Alert data-color='success'>
      Resultatene er sendt. Vedlegg lastes opp separat nedenfor. Analysen er
      ikke markert som fullført av dette verktøyet.
    </Mtds.Alert>
    <Mtds.Flex>
      <Mtds.Info>
        <strong>Rekvisisjon</strong>
        {receipt.requisitionId}
      </Mtds.Info>
      <Mtds.Info>
        <strong>Prøve</strong>
        {receipt.data.id}
      </Mtds.Info>
      <Mtds.Info>
        <strong>Rapporterte substanser</strong>
        {receipt.data.reportedSubstanceCount} /{' '}
        {receipt.data.totalSubstanceCount}
      </Mtds.Info>
    </Mtds.Flex>
    <Mtds.Info>
      <strong>Gjenstående substanskoder</strong>
      {receipt.data.pendingSubstanceCodes.join(', ') || 'Ingen'}
    </Mtds.Info>
    <Mtds.Grid data-items='250'>
      {receipt.data.results.map((result) => (
        <Mtds.Info key={result.id}>
          <strong>Resultat-ID {result.id}</strong>
          {result.substance || 'Ingen substans oppgitt'}; delprøve{' '}
          {result.subSampleId ?? 'ikke oppgitt'}
        </Mtds.Info>
      ))}
    </Mtds.Grid>
  </Mtds.Card>
)
